/* Corazon site chrome: keeps the header cart count number in sync with the real cart.
   The cart drawer, the apps and the in-house sections change the cart with /cart/add|change|update|clear(.js)
   calls; Impulse's own count updater only runs for its built-in drawer. This watches those calls (fetch + XHR),
   reads /cart.js once (debounced) and updates every [data-cgc-cart-count] + the bubble's visible class.
   Read-only: it never changes the cart. */
(function () {
  if (window.__cgcChrome) return;
  window.__cgcChrome = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var nativeFetch = window.fetch ? window.fetch.bind(window) : null;
  var MUTATE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var READ = /\/cart\.js(\?|$)/;
  var timer = null;

  function set(n) {
    n = parseInt(n, 10) || 0;
    document.querySelectorAll('[data-cgc-cart-count]').forEach(function (el) {
      el.textContent = n > 99 ? '99+' : String(n);
      var b = el.closest('.cart-link__bubble');
      if (b) b.classList.toggle('cart-link__bubble--visible', n > 0);
    });
    document.querySelectorAll('.js-drawer-open-cart').forEach(function (a) {
      a.setAttribute('data-cart-count', n);
    });
  }

  /* the in-house shipping protection line (assets/cgc-cart.js) is not an item the customer picked: never count it */
  function countOf(c) {
    var n = (c && c.item_count) || 0;
    var P = window.__cgcCart && window.__cgcCart.protection && window.__cgcCart.protection.cfg;
    if (P && c && c.items) c.items.forEach(function (it) { if (+it.variant_id === +P.variant) n -= +it.quantity || 0; });
    return Math.max(0, n);
  }

  function refresh() {
    if (!nativeFetch) return;
    clearTimeout(timer);
    timer = setTimeout(function () {
      nativeFetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { set(countOf(c)); })
        .catch(function () {});
    }, 250);
  }

  function urlOf(input) {
    try { return typeof input === 'string' ? input : (input && input.url) || String(input); } catch (e) { return ''; }
  }

  function bodyMentionsCart(body) {
    return typeof body === 'string' && /cartLines|cartCreate|cartBuyerIdentity/.test(body);
  }

  if (nativeFetch) {
    window.fetch = function (input, init) {
      var url = urlOf(input);
      var p = nativeFetch(input, init);
      try {
        if (MUTATE.test(url) || (/graphql/.test(url) && init && bodyMentionsCart(init.body))) {
          p.then(function (res) { if (res && res.ok) refresh(); }, function () {});
        } else if (READ.test(url)) {
          p.then(function (res) {
            if (res && res.ok) res.clone().json().then(function (c) { if (c && 'item_count' in c) set(countOf(c)); }, function () {});
          }, function () {});
        }
      } catch (e) {}
      return p;
    };
  }

  var xOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__cgcUrl = String(url || '');
    return xOpen.apply(this, arguments);
  };
  var xSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    var x = this, url = x.__cgcUrl || '';
    if (MUTATE.test(url) || READ.test(url)) {
      x.addEventListener('load', function () {
        if (x.status < 200 || x.status >= 300) return;
        if (MUTATE.test(url)) return refresh();
        try { var c = JSON.parse(x.responseText); if (c && 'item_count' in c) set(countOf(c)); } catch (e) {}
      });
    }
    return xSend.apply(this, arguments);
  };

  document.addEventListener('cart:updated', function (e) {
    if (e.detail && e.detail.cart && 'item_count' in e.detail.cart) set(countOf(e.detail.cart));
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  /* first paint: Liquid prints the count without the protection line (snippets/header-icons.liquid); the cart drawer
     (assets/cgc-drawer.js) hands over the cart the page printed. Read /cart.js only when neither is there. */
  function firstCount() {
    var c = window.CGCCart && window.CGCCart.cart, el = document.querySelector('[data-cgc-cart-count]');
    if (c && c.items) set(countOf(c));
    else if (el && !el.hasAttribute('data-cgc-exact') && parseInt(el.textContent, 10) > 0) refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', firstCount); else firstCount();
})();
